import React from "react";

import { IButtonProps } from "@/components/Button";
import { ModalButton } from "@/views/components/Modal";

import { CreateCompanyDialogModal } from "./CreateCompanyDialogModal";

interface Props extends Omit<IButtonProps, "ref"> {}

export const CreateCompanyDialogModalButton = React.memo(({ ...buttonProps }: Props) => {
  return <ModalButton openable={CreateCompanyDialogModal} openableProps={{ size: "xs" }} {...buttonProps} />;
});
